import {Authority} from '@/oauth/Authority';
import {AuthorityDto} from '@/oauth/AuthorityDto';
import {AuthStore} from '@/oauth/AuthStore';
import {User} from '@/oauth/User';
import {getModule} from 'vuex-module-decorators';
import {AuthTokenDto} from '@/oauth/AuthTokenDto';
import router from '@/router';

export class SecurityUtils {
    private static authStore = getModule(AuthStore);
    
    public static getLoginUser() {
        if (!this.goToLogin()) {
            return new User();
        }
        const token = AuthTokenDto.getOrLogin();
        const user = this.authStore.loginUser;
        const u = User.of(user) as User;
        if (token.getUsername() === u.username) {
            return u;
        } else {
            this.goToLogin();
            throw Error('用户名与令牌用户名不符!' + token.getUsername() + u.username);
        }
    }
    
    /**
     * 如果没有登录前往登录页面,已登录返回false
     * @returns {boolean} 是否已登录
     */
    public static goToLogin() {
        if (!this.isLoggedIn()) {
            if (router.currentRoute.name !== 'login') {
                router.push({name: 'login'});
            }
            return false;
        }
        return true;
    }
    
    /**
     * 用户是否已登录
     *
     */
    public static isLoggedIn(): boolean {
        return User.of(this.authStore.loginUser).username !== '';
    }
    
    /**
     * 登出
     * 清除token并返回登录页面
     */
    public static logout() {
        AuthTokenDto.logout();
        this.authStore.setLoginUser(new User());
        this.goToLogin();
    }
    
    public static getAllAuthorities(): Authority[] {
        const list = this.authStore.authorities;
        if (list.length === 0) {
            this.refreshAuthorities();
        }
        return list;
    }
    
    public static async refreshAuthorities() {
        return await AuthorityDto.getAllAuthorities();
    }
    
    public static getAllRole(authorities = this.getAllAuthorities()): Authority[] {
        return authorities.filter((a) => {
            if (a.authority) {
                return Boolean(a.authority.match(/^ROLE_.+/));
            }
            return false;
        });
    }
    
    public static getAllPermission(authorities = this.getAllAuthorities()): Authority[] {
        return authorities.filter((a) => {
            if (a.authority) {
                return Boolean(a.authority.match(/^PERMISSION_.+/));
            }
            return false;
        });
    }
    
    public static getOtherAuthority(authorities = this.getAllAuthorities()) {
        const allPermission = this.getAllPermission(authorities);
        const allRole = this.getAllRole(authorities);
        return authorities.filter(a => {
            return !(allPermission.some(p => p.id === a.id) || allRole.some(r => r.id === a.id));
        });
    }
    
    public static removePrefix(as: string) {
        as = as.toUpperCase();
        as = as.replace(/^ROLE_/, '');
        as = as.replace(/^PERMISSION_/, '');
        return as;
    }
    
    public static createNodeTree(al: Authority[]): QTreeNode[] {
        const tree: QTreeNode[] = [];
        al.forEach((a) => {
            const childNode = this.createChildNode([], a, 0);
            this.joinTree(tree, childNode);
        });
        return tree;
    }
    
    private static createChildNode(tree: QTreeNode[] | undefined,
                                   a: Authority,
                                   index: number): QTreeNode[] {
        if (typeof tree === 'undefined') {
            tree = [];
        }
        const strings: string[] = [a.authority];
        const current = strings[index];
        const isLast = strings.length - 1 === index;
        const isOutOfIndex = index >= strings.length;
        if (isOutOfIndex) {
            index = 0;
            return [];
        } else {
            index++;
        }
        
        if (typeof current !== 'undefined' && !isOutOfIndex) {
            const c = this.createChildNode(tree, a, index);
            tree = [{
                id: Date.now() + (a.id ? a.id : 0),
                label: isLast ? a.authority : current,
                children: c,
                selectable: isLast,
                header: isLast ? 'selectable' : undefined,
            }];
            return tree;
        }
        return [];
    }
    
    public static joinTree(tree: QTreeNode[], childNode: QTreeNode[] | undefined) {
        // 检测当层子节点是否有同名,非同名直接加入子节点
        if (typeof childNode !== 'undefined') {
            childNode.forEach((cn) => {
                if (!tree.some((tn) => {
                    return tn.label === cn.label;
                })) {
                    tree.push(cn);
                }
            });
            // 同名节点继续向下合并
            tree.forEach((tn) => {
                childNode.forEach((cn) => {
                    if (tn.label === cn.label) {
                        if (typeof tn.children !== 'undefined') {
                            this.joinTree(tn.children, cn.children);
                        }
                    }
                });
                
                
            });
        }
    }

    public static getToken() {
        return AuthTokenDto.getOrLogin();
    }

    public static getTokenAuthorities(startWith = '') {
        return this.getToken().getAuthoritys().filter(value => value.startsWith(startWith));
    }
}
